Unsplash = require('unsplash-js/dist/unsplash')


module.exports = {
  unsplashApi: new Unsplash.default
    applicationId: "454087647775b190c574339cb2994716b17ef2f83ad11838d0ef0dac2d102e66"

  toJson: Unsplash.toJson
}



// WEBPACK FOOTER //
// ./app/scripts/network/unsplash.coffee